import { Navigate, useParams } from "react-router-dom";

export default function TicketsRedirect() {
  const { ticketId } = useParams();
  return <Navigate to={`/agent/${ticketId}`} replace />;
}
